export enum paymentStatusEnum {
    Paid = 1,
    UnPaid = 2,
    PartiallyPaid = 3,
}

export const PaymentStatusesEnumArray = [
    { text: 'Paid', value: paymentStatusEnum.Paid },
    { text: 'Un Paid', value: paymentStatusEnum.UnPaid },
    { text: 'Partially Paid', value: paymentStatusEnum.PartiallyPaid },
];